import React from "react";
import CCOContainer from "../../fundamentals/CCOContainer";
import CAEGlobalSettings from "../../../types/CAEGlobalSettings";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import EmailIcon from "@mui/icons-material/Email";

import {CmCollectionType, CmLinkableType} from "../../types";
import CCOHeadline from "../../fundamentals/CCOHeadline";
import {link} from "./FooterMenu";
import useWindowSize from "../../../utility/useWindowSize";
import Typography from "@mui/material/Typography";
import {copyRightStyle} from "../../content/C074CopyrightNavi/C074CopyrightNavi";
import Box from "@mui/material/Box";


export interface Props {
    items: Array<CmLinkableType>,
    CAEGlobalSettings: CAEGlobalSettings,
}


const footerLinkSx = {
    color: "footerLink.main",
    fontSize: "18px !important;",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "200%",
    letterSpacing: "0.25px",
    fontFeatureSettings: "'liga' off, 'clig' off",
    textDecorationLine: "underline",
    textDecorationStyle: "solid",
    textDecorationSkipInk: "none",
    textUnderlinePosition: "from-font",
} as const;

const footerLinkWrapperSx = {
    "& a": {
        textDecoration: "none",
    },
    "& .MuiTypography-root, & .MuiTypography-root:hover": {
        color: footerLinkSx.color,
        fontSize: footerLinkSx.fontSize,
        fontStyle: footerLinkSx.fontStyle,
        fontWeight: footerLinkSx.fontWeight,
        lineHeight: footerLinkSx.lineHeight,
        letterSpacing: footerLinkSx.letterSpacing,
        fontFeatureSettings: footerLinkSx.fontFeatureSettings,
        textDecorationLine: footerLinkSx.textDecorationLine,
        textDecorationStyle: footerLinkSx.textDecorationStyle,
        textDecorationSkipInk: footerLinkSx.textDecorationSkipInk,
        textUnderlinePosition: footerLinkSx.textUnderlinePosition,
        textDecorationThickness: "auto",
        textUnderlineOffset: "auto",
        py: 0,
    },
} as const;

function EasyLangFooter(props: Props) {
    const {lowerThanWindowLarge} = useWindowSize();
    const footer = props.items as CmCollectionType[];

    function renderContact(linkItem: CmLinkableType, index: number, teaserTitle: string, isEamil: boolean) {
        const url: string = (linkItem as any).url ?? "";
        const label = (linkItem as any)?.teaserTitle ?? (linkItem as any)?.title ?? "";
        return (
            <Stack
                key={index}
                direction="row"
                sx={{
                    alignItems: "center",
                    gap: 1
                }}>
                {isEamil ? <EmailIcon fontSize="small" sx={{color: footerLinkSx.color}}/> :
                    <PhoneIphoneIcon fontSize="small" sx={{color: footerLinkSx.color}}/>}
                <Typography
                    component="a"
                    href={url.trim()}
                    target="_self"
                    rel="noopener"
                    sx={{display: "flex", ...footerLinkSx}}
                    data-cypress={teaserTitle + index}
                >
                    {label}
                </Typography>
            </Stack>
        );
    }

    return (
        <CCOContainer component="footer"
                             dataCypress='footer'
                             id={"footer"}
                             alignLeft={!lowerThanWindowLarge}
                             width={"full"}
                             background={"grey"}
                             border={true}
                             marginTop={12}
                             sx={{borderTop: "1px solid #3B8511", overflowX: "hidden"}}
                             withMobilePadding>
            <Grid container spacing={4} sx={{py: 4}}>
                {
                    footer && footer.map((f) => (
                        f?.items?.map((i, index) => {
                            const item = i as CmCollectionType;
                            return (
                                <Grid key={index} size={{xs: 12, md: 4}} sx={{
                                    mt: index === 0 ? 0 : lowerThanWindowLarge ? 8 : 0
                                }}>
                                    <CCOHeadline headline={item?.teaserTitle} type="h4" justify="left"/>
                                    {item?.items?.map((li, num: number) => {
                                        const linkItem = li as CmLinkableType;
                                        const url: string = (linkItem as any).url ?? "";
                                        if (url.startsWith("tel:")) {
                                            return renderContact(linkItem, num, item?.teaserTitle ?? "", false);
                                        }
                                        if (url.startsWith("mailto:")) {
                                            return renderContact(linkItem, num, item?.teaserTitle ?? "", true);
                                        }
                                        return (
                                            <Box key={num} sx={footerLinkWrapperSx}>
                                                {link(linkItem?.title ?? "", linkItem, num)}
                                            </Box>
                                        );
                                    })}
                                </Grid>
                            );
                        })
                    ))
                }
            </Grid>
            <Box sx={{
                borderTop: "1px solid #D5D5D5",
                px: 0,
                mx: "-100vw",
                mt: 12,
                mb: 4,
                width: "300vw",
                position: "relative",
                left: "50%",
                transform: "translateX(-50%)"
            }}>
            </Box>

            <Grid container sx={{py: 4, textAlign: "left"}}>
                <Grid size={{xs: 12, md: 12}}>
                    <Typography
                        sx={copyRightStyle}> &copy; {new Date().getFullYear()} {props.CAEGlobalSettings["copyright"]} </Typography>
                </Grid>
            </Grid>
        </CCOContainer>
    );
}

export default EasyLangFooter
